import SectionHistory from './SectionHistory'
import SectionBids from './SectionBids'

/**
 * SectionCardDown component.
 *
 * Bottom section of item details page showing:
 * - SectionBids: List of current bids/offers
 * - SectionHistory: Activity history of the item
 *
 * Only renders if auction data exists for the item.
 *
 * @param {Object} props - Component props
 * @param {Object} props.data1 - Collection data (passed to SectionBids)
 * @param {Object} props.data2 - Collection data (passed to SectionHistory)
 * @param {Object} props.ti - Token/item information with auctionData
 * @returns {React.ReactElement} Lower card section with bids and history
 */
function SectionCardDown({ data1 , data2, ti }){
//	    <SectionHistory data={data2} />
  return(
	<>
		{ ti?.auctionData ?
	    <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
            <SectionBids data={data1} ti={ti}/>
            <SectionHistory data={data2} ti={ti}/>
        </div>
            : null }
	</>
  )
}

export default SectionCardDown
